// API Configuration
// Centralized configuration for API endpoints

// Auto-detect API URL based on environment
const getApiBaseUrl = (): string => {
  // 1. If REACT_APP_API_URL is explicitly set, use it
  //    This MUST be set at build time for production/sandbox builds
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Development default (backend runs on port 4001)
  //    No hardcoded production URL — missing REACT_APP_API_URL in prod builds
  //    will fall back here, making misconfiguration immediately visible
  return 'http://localhost:4001';
};

export const API_BASE_URL = getApiBaseUrl();

export const WS_BASE_URL = process.env.REACT_APP_WS_URL || 
  (API_BASE_URL.replace('http://', 'ws://').replace('https://', 'wss://'));

export const CHAT_WIDGET_URL = `${API_BASE_URL}/chat-widget.js`;

// Export default for convenience
const apiConfig = {
  API_BASE_URL,
  WS_BASE_URL,
  CHAT_WIDGET_URL,
};

export default apiConfig;

